export default {
  robotmonLogoUrl: require('./robotmon_logo_1024x1024.png'),
  intro1en: require('./intro1_en.jpg'),
  intro2en: require('./intro2_en.jpg'),
  intro1zh: require('./intro1_zh.jpg'),
  intro2zh: require('./intro2_zh.jpg'),
  intro1ja: require('./intro1_ja.jpg'),
  intro2ja: require('./intro2_ja.jpg'),
  intro1ko: require('./intro1_ko.jpg'),
  intro2ko: require('./intro2_ko.jpg'),
  tsumLogoUrl: require('./tsum.jpg'),
  cookieKingdomLogoUrl: require('./cookie_kingdom_logo.jpg'),
  mlb9iLogoUrl: require('./mlb9i.jpg'),
  gamesGifUrl: require('./games.gif'),
  noGamesUrl: require('./no_games.png'),
  allIcons: require('./all_icons.png'),
  christmasImgUrl: require('./christmas-2024.png'),
  thanks_en: require('./thanks_en.png'),
  thanks_zh: require('./thanks_zh.png'),
  thanks_ja: require('./thanks_ja.png'),
};
